var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
/* eslint-disable no-restricted-globals */
import React from 'react';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';
import { Col } from '@amzn/atoz-web/Col';
import { Row } from '@amzn/atoz-web/Row';
import { Text } from '@amzn/atoz-web/Text';
import { View } from '@amzn/atoz-web/View';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { TextTimeInput } from './TimeTextInput';
export var TEXT_TIME_INPUT_FORMAT = 'hh:mm a';
export var TimeRangePicker = function (_a) {
    var setRangeStart = _a.setRangeStart, setRangeEnd = _a.setRangeEnd, startTime = _a.startTime, endTime = _a.endTime;
    var t = useTranslation().t;
    var _b = React.useState(''), startTimeText = _b[0], setStartTimeText = _b[1];
    var _c = React.useState(''), endTimeText = _c[0], setEndTimeText = _c[1];
    React.useEffect(function () {
        if (!startTime) {
            setStartTimeText('');
        }
        else {
            setStartTimeText(startTime.toFormat('hh:mm a').toLowerCase());
        }
    }, [startTime]);
    React.useEffect(function () {
        if (!endTime) {
            setEndTimeText('');
        }
        else {
            setEndTimeText(endTime.toFormat('hh:mm a').toLowerCase());
        }
    }, [endTime]);
    function onStartChange(newStartTime) {
        setStartTimeText(newStartTime);
        var time = DateTime.fromFormat(newStartTime, TEXT_TIME_INPUT_FORMAT, {
            locale: 'en-US'
        });
        setRangeStart(time.isValid ? time : undefined);
    }
    function onEndChange(newEndTime) {
        setEndTimeText(newEndTime);
        var time = DateTime.fromFormat(newEndTime, TEXT_TIME_INPUT_FORMAT, {
            locale: 'en-US'
        });
        setRangeEnd(time.isValid ? time : undefined);
    }
    var placeholderText = t('shift_management_views_filters_TimeRangePicker_placeholder');
    return (React.createElement(Row, { justifyContent: "space-between", dataTestId: "TimeRangePicker", role: "group", "aria-label": t('shift_management_views_filters_TimeRangePicker_ariaLabel') },
        React.createElement(Col, { gridGap: "S100" },
            React.createElement(Text, { fontSize: "T200", fontWeight: "bold" }, t('shift_management_views_filters_TimeRangePicker_start')),
            React.createElement(Text, { fontSize: "T100" }, t('shift_management_views_filters_TimeRangePicker_startExample')),
            React.createElement(TextTimeInputWrapper, null,
                React.createElement(TextTimeInput, { onChange: onStartChange, placeholder: placeholderText, value: startTimeText }))),
        React.createElement(Col, { gridGap: "S100" },
            React.createElement(ConjunctionText, { fontSize: "T100" }, t('shift_management_views_filters_TimeRangePicker_conjunction'))),
        React.createElement(Col, { gridGap: "S100" },
            React.createElement(Text, { fontSize: "T200", fontWeight: "bold" }, t('shift_management_views_filters_TimeRangePicker_end')),
            React.createElement(Text, { fontSize: "T100" }, t('shift_management_views_filters_TimeRangePicker_endExample')),
            React.createElement(TextTimeInputWrapper, null,
                React.createElement(TextTimeInput, { onChange: onEndChange, placeholder: placeholderText, value: endTimeText })))));
};
var TextTimeInputWrapper = styledWithTheme(View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-top: auto;\n"], ["\n    margin-top: auto;\n"])));
var ConjunctionText = styledWithTheme(Text)(function (_a) {
    var theme = _a.theme;
    return "\n    margin-top: auto;\n    margin-bottom: ".concat(theme.selectors.space('S200'), "px;\n    margin-left: 10px;\n    margin-right: 10px;\n");
});
var templateObject_1;
